import { render, staticRenderFns } from "./BackstageAccount.vue?vue&type=template&id=18464006&scoped=true&"
import script from "./BackstageAccount.vue?vue&type=script&lang=js&"
export * from "./BackstageAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18464006",
  null
  
)

export default component.exports